export default __webpack_public_path__ + "febb17aaf07056984d2c54ecf0d7df36.svg";